(() => {
  const ROOT_SELECTOR = '[data-cradri-subscription-preferences]';

  function safeParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function init(root) {
    if (!root || root.dataset.cradriInitialized === 'true') return;
    root.dataset.cradriInitialized = 'true';

    const formId = root.dataset.formId;
    const productId = root.dataset.productId || 'product';
    const form = document.getElementById(formId);
    const storageKey = `cradri-subscription-preferences:${productId}`;

    const state = {
      flavors: [],
      sweetness: '',
      drinks: [],
      adventure: '',
      avoid: '',
      step: 1,
      complete: false
    };

    const stored = safeParse(sessionStorage.getItem(storageKey));
    if (stored && typeof stored === 'object') {
      state.flavors = Array.isArray(stored.flavors) ? stored.flavors : [];
      state.sweetness = typeof stored.sweetness === 'string' ? stored.sweetness : '';
      state.drinks = Array.isArray(stored.drinks) ? stored.drinks : [];
      state.adventure = typeof stored.adventure === 'string' ? stored.adventure : '';
      state.avoid = typeof stored.avoid === 'string' ? stored.avoid : '';
      state.step = Number.isInteger(stored.step) ? Math.min(Math.max(stored.step, 1), 5) : 1;
      state.complete = stored.complete === true;
    }

    const steps = [...root.querySelectorAll('[data-step]')];
    const summary = root.querySelector('[data-summary]');
    const progressCurrent = root.querySelector('[data-progress-current]');
    const progressBar = root.querySelector('[data-progress-bar]');
    const errorBox = root.querySelector('[data-error]');
    const avoidInput = root.querySelector('[data-avoid-input]');

    const outputs = {
      flavors: root.querySelector('[data-output="flavors"]'),
      sweetness: root.querySelector('[data-output="sweetness"]'),
      drinks: root.querySelector('[data-output="drinks"]'),
      adventure: root.querySelector('[data-output="adventure"]'),
      avoid: root.querySelector('[data-output="avoid"]')
    };

    function save() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(state));
      } catch (error) {
        // Storage can be unavailable in private browsing. The form still works.
      }
    }

    function joined(values) {
      return values.filter(Boolean).join(' / ');
    }

    function syncOutputs() {
      if (outputs.flavors) outputs.flavors.value = joined(state.flavors);
      if (outputs.sweetness) outputs.sweetness.value = state.sweetness;
      if (outputs.drinks) outputs.drinks.value = joined(state.drinks);
      if (outputs.adventure) outputs.adventure.value = state.adventure;
      if (outputs.avoid) outputs.avoid.value = state.avoid.trim() || '特になし';
      if (avoidInput && avoidInput.value !== state.avoid) avoidInput.value = state.avoid;
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.hidden = true;
    }

    function markButtons() {
      root.querySelectorAll('[data-group]').forEach((group) => {
        const key = group.dataset.group;
        const selected = Array.isArray(state[key]) ? state[key] : [state[key]];
        group.querySelectorAll('[data-value]').forEach((button) => {
          button.setAttribute('aria-pressed', selected.includes(button.dataset.value) ? 'true' : 'false');
        });
      });
    }

    function renderSummary() {
      const summaryValues = {
        flavors: joined(state.flavors) || '未回答',
        sweetness: state.sweetness || '未回答',
        drinks: joined(state.drinks) || '未回答',
        adventure: state.adventure || '未回答',
        avoid: state.avoid.trim() || '特になし'
      };

      Object.entries(summaryValues).forEach(([key, value]) => {
        const node = root.querySelector(`[data-summary-${key}]`);
        if (node) node.textContent = value;
      });
    }

    function render() {
      syncOutputs();
      markButtons();

      if (state.complete) {
        steps.forEach((step) => { step.hidden = true; });
        if (summary) summary.hidden = false;
        if (progressCurrent) progressCurrent.textContent = '5';
        if (progressBar) progressBar.style.width = '100%';
        renderSummary();
      } else {
        if (summary) summary.hidden = true;
        steps.forEach((step) => {
          step.hidden = Number(step.dataset.step) !== state.step;
        });
        if (progressCurrent) progressCurrent.textContent = String(state.step);
        if (progressBar) progressBar.style.width = `${state.step * 20}%`;
      }

      save();
    }

    function validStep(step) {
      if (step === 1 && state.flavors.length === 0) {
        showError('好きな味を1つ以上選んでください。');
        return false;
      }
      if (step === 2 && !state.sweetness) {
        showError('甘さの好みを選んでください。');
        return false;
      }
      if (step === 3 && state.drinks.length === 0) {
        showError('よくする飲み方を1つ以上選んでください。');
        return false;
      }
      if (step === 4 && !state.adventure) {
        showError('冒険度を選んでください。');
        return false;
      }
      clearError();
      return true;
    }

    root.querySelectorAll('[data-group]').forEach((group) => {
      const key = group.dataset.group;
      const mode = group.dataset.mode;
      const max = Number(group.dataset.max || 0);
      const exclusive = group.dataset.exclusive || '';

      group.querySelectorAll('[data-value]').forEach((button) => {
        button.addEventListener('click', () => {
          clearError();
          const value = button.dataset.value;

          if (mode === 'single') {
            state[key] = value;
          } else {
            let values = Array.isArray(state[key]) ? [...state[key]] : [];
            const isSelected = values.includes(value);

            if (isSelected) {
              values = values.filter((item) => item !== value);
            } else if (exclusive && value === exclusive) {
              values = [value];
            } else {
              if (exclusive) values = values.filter((item) => item !== exclusive);
              if (max && values.length >= max) {
                showError(`最大${max}つまで選べます。`);
                return;
              }
              values.push(value);
            }
            state[key] = values;
          }

          state.complete = false;
          render();
        });
      });
    });

    root.querySelectorAll('[data-next]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!validStep(state.step)) return;
        state.step = Math.min(state.step + 1, 5);
        state.complete = false;
        clearError();
        render();
      });
    });

    root.querySelectorAll('[data-back]').forEach((button) => {
      button.addEventListener('click', () => {
        state.step = Math.max(state.step - 1, 1);
        state.complete = false;
        clearError();
        render();
      });
    });

    const completeButton = root.querySelector('[data-complete]');
    if (completeButton) {
      completeButton.addEventListener('click', () => {
        state.avoid = avoidInput ? avoidInput.value.trim() : '';
        if (!validStep(4)) {
          state.step = 4;
          render();
          return;
        }
        state.complete = true;
        clearError();
        render();
      });
    }

    const editButton = root.querySelector('[data-edit]');
    if (editButton) {
      editButton.addEventListener('click', () => {
        state.complete = false;
        state.step = 1;
        render();
      });
    }

    if (avoidInput) {
      avoidInput.addEventListener('input', () => {
        state.avoid = avoidInput.value;
        state.complete = false;
        save();
      });
    }

    const guideButton = root.querySelector('[data-purchase-guide]');
    if (guideButton) {
      guideButton.addEventListener('click', () => {
        const block = root.closest('[data-block-id]');
        let target = block ? block.nextElementSibling : null;
        while (target && !target.querySelector('form') && !target.matches('form')) {
          target = target.nextElementSibling;
        }
        (target || form || root).scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    if (form) {
      form.addEventListener('submit', (event) => {
        state.avoid = avoidInput ? avoidInput.value.trim() : '';
        syncOutputs();

        if (!state.complete || !validStep(1) || !validStep(2) || !validStep(3) || !validStep(4)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          state.complete = false;
          const firstInvalid = state.flavors.length === 0 ? 1 : !state.sweetness ? 2 : state.drinks.length === 0 ? 3 : !state.adventure ? 4 : 5;
          state.step = firstInvalid;
          showError('定期便を購入する前に、5つの質問への回答を完了してください。');
          render();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        save();
      }, true);
    }

    render();
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length > 0)) initAll();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
